import script from "./OrderEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderEdit.vue?vue&type=script&setup=true&lang=js"

import "./OrderEdit.vue?vue&type=style&index=0&id=74fbe614&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fbe614"]])

export default __exports__